import React from 'react';
import { Button } from 'fronton-react';
import { CardType } from '../../types';
import { CatalogueOrderButton, PopularOrderButton } from '../buttons-content';
import { PopularButton } from '../buttons-content/popular-button';

import { SmallBtn, Btn } from './styles';

type CardButtonProps = {
	priceText: string;
	unitOfMeasurement: string;
	cardType: keyof typeof CardType;
};

export const CardButton = ({ priceText, unitOfMeasurement, cardType }: CardButtonProps) => {
	let child;
	let classname = '';

	switch (cardType) {
		case CardType.popularOrder:
			child = <PopularOrderButton />;
			break;
		case CardType.catalogueOrder:
			child = (
				<CatalogueOrderButton unitOfMeasurement={unitOfMeasurement} priceText={priceText} />
			);
			classname = SmallBtn;
			break;
		case CardType.popular:
			child = <PopularButton />;
			break;
	}

	return (
		<Button
			kind="regular"
			size="m"
			variant="primary"
			className={`${classname} ${Btn}`}
			data-analyticsName="productButtonLink"
		>
			{child}
		</Button>
	);
};
